module.exports = __webpack_public_path__ + "img/pics-icon.51569871.svg";